// Angular
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RecaptchaModule } from "ng-recaptcha";
// Material
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// CRUD
import { InterceptService } from '../../../core/_base/crud/';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthNoticeComponent } from './auth-notice/auth-notice.component';
// Auth
import { AuthService, authReducer, AuthGuard, AuthEffects, RouteRedirectGuard } from '../../../core/auth';
import { RegisterAdminComponent } from './register-admin/register-admin.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MenuConfig } from '../../../core/_config/demo2/menu.config';
import { VerifyComponent } from './verify/verify.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { PrimitivesModule } from '../../components/primitives/primitives.module';
import { PasswordRequirementsComponent } from './password-requirements/password-requirements.component';
import { ButtonModule } from '../../components/button/button.module';
const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		canActivate: [RouteRedirectGuard],
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'subscription',
				component: SubscriptionComponent
			},
			{
				path: 'login',
				component: LoginComponent
			},
			{
				path: 'register',
				component: RegisterComponent
			},
			{
				path: 'register-admin',
				component: RegisterAdminComponent
			},
			{
				path: 'forgot-password',
				component: ForgotPasswordComponent,
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
			},
			{
				path: 'verify-otp',
				component: VerifyComponent,
			}
		]
	}
];


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		RouterModule.forChild(routes),
		MatInputModule,
		NgbCarouselModule,
		MatFormFieldModule,
		MatCheckboxModule,
		MatIconModule,
		TranslateModule.forChild(),
		StoreModule.forFeature('auth', authReducer),
		EffectsModule.forFeature([AuthEffects]),
		RecaptchaModule,
		PrimitivesModule,
		ButtonModule
	],
	providers: [
		InterceptService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
		},
	],
	exports: [AuthComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		RegisterComponent,
		ForgotPasswordComponent,
		AuthNoticeComponent,
		RegisterAdminComponent,
		ResetPasswordComponent,
		SubscriptionComponent,
		VerifyComponent,
		PasswordRequirementsComponent
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders<AuthModule> {
		return {
			ngModule: AuthModule,
			providers: [
				AuthService,
				MenuConfig,
				AuthGuard
			]
		};
	}
}
